(function() {
    'use strict';
    angular
        .module('quantixApp')
        .factory('AIFBenchmarkService', AIFBenchmarkService);

    AIFBenchmarkService.$inject = ['$http', '$q'];

    function AIFBenchmarkService($http, $q) {

        var uploadExcelTemplate = function(formData) {
            var deferred = $q.defer();
            $http.post('api/aifbenchmark/uploadaifexcel', formData, {
                responseType : 'application/json',
                  headers : {
                         'Content-Type' : undefined
                  }}).then(function(response) {
                            deferred.resolve(response);
                    }, function(errordata) {
                    deferred.reject(errordata);
                });
           return deferred.promise;
        }

        var getHistoricalData = function() {
            var deferred = $q.defer();
            $http.get('api/aifbenchmark/gethistoricaldata', {
                responseType : 'application/json',
                  headers : {
                         'Content-Type' : 'application/json'
                  }}).then(function(response) {
                        deferred.resolve(response);
                    }, function(errordata) {
                    deferred.reject(errordata);
                });
           return deferred.promise;
        }
		return {
            uploadExcelTemplate : uploadExcelTemplate,
            getHistoricalData : getHistoricalData
        }

    }
})();